module.exports = __webpack_public_path__ + "static/media/business-lunch-food-court-4.5189262a.jpg";